import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Fragment } from 'react';
import { chunkArray, chunkByBreakingIndexes, toSlug } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';

const link = (isParent, useNormalFontForParents, cat) => {
    return (
        <a className='accordion__category-link' href={cat.RawURL}>
            {isParent ?
                (useNormalFontForParents ?
                    <span dangerouslySetInnerHTML={{ __html: cat.Name }}></span> :
                    <b dangerouslySetInnerHTML={{ __html: cat.Name }}></b>) :
                <span dangerouslySetInnerHTML={{ __html: cat.Name }}></span>}
        </a>
    );
}

const createDrilldown = (key, fullCategoryList, numColumns, removeChildren, useNormalFontForParents) => {
    if (!numColumns) numColumns = 1;
    var list = [];

    let colBreakIndexes = fullCategoryList.map((e, i) => e.isColumnBreaker ? i : undefined).filter(x => x);
    if (colBreakIndexes.length > 0) {
        list = chunkByBreakingIndexes(fullCategoryList, colBreakIndexes);
    }

    if (list.length <= 0) {
        list = chunkArray(fullCategoryList, numColumns, removeChildren);
    }

    return list.map((catlist, idx) => {
        return (
            <Fragment {...(key ? { key: `${key}-list-${idx}-${catlist.length}` } : {})}>
                {createDrilldownLinks(`${key}-list${idx}-ul`, catlist, useNormalFontForParents)}
            </Fragment>
        );
    });
};

const createDrilldownLinks = (key, categoryList, useNormalFontForParents) => {
    return categoryList.map((cat, idx) => {
        let isParent = cat.Children?.length > 0;
        let numColumns = isParent ? cat.Columns : 0;
        let children = chunkArray(cat.Children || [], numColumns, null);
        return (
            <Fragment {...(key ? { key: `${key}-cat-${idx}` } : {})}>
                {isParent ?
                    <ul className='accordion__category-list' key={`accordion-ul-${cat.Name}-${idx}`}>
                        <li className='accordion__category-parent' key={`li-sub-list-${cat.Name}-${idx}`}>
                            {link(isParent, useNormalFontForParents, cat)}
                        </li>
                        <ul className='accordion__category-sub-list' key={`ul-sub-list-${cat.Name}-${idx}`}>
                            {children.map(child => createDrilldown(`${key}-dd-div`, child, 1))}
                        </ul>
                    </ul> :
                    <li key={`li-${cat.Name}-i`} className='accordion__category-list-item'>
                        {link(isParent, useNormalFontForParents, cat)}
                        {isParent && children.map(child => createDrilldown(`${key}-dd-li`, child, 1, true, false))}
                    </li>}
            </Fragment>
        );
    });
};

const SandhillsAccordion = (props) => {
    const {
        className,
        accordionTitle,
        categories,
        mapDetails,
        viewAllRoute
    } = props;

    const accordionId = props?.isRentalAccordion && !accordionTitle?.includes("For Rent") && !accordionTitle?.includes("For Lease") ? `panel-${toSlug(accordionTitle)}-for-rent-header` : `panel-${toSlug(accordionTitle)}-header`;

    return (
        <div className={(className ? className : '')}>
            <Accordion disableGutters>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-${toSlug(accordionTitle)}-content`}
                    id={accordionId}
                    className="accordion-header"
                >
                    {accordionTitle}
                </AccordionSummary>

                <AccordionDetails>
                    {mapDetails ?
                        <>
                            <div className='accordion-columns'>
                                {categories &&
                                    <>
                                        {categories && createDrilldown(`dd-${accordionTitle}`, categories, 4)}
                                    </>
                                }
                            </div>
                        </>
                        :
                        <>
                            {categories && categories.Categories?.length > 0 &&
                                <div className='accordion-columns'>
                                    {createDrilldown(`pac-dd-${categories.ListingTitle}`, categories.Categories, null, false)}
                                </div>}
                        </>
                    }
                    {viewAllRoute &&
                        <div className='accordion__btn-container'>
                            <a className='ts-button btn accordion__btn' href={viewAllRoute}><TranslationText tKey='sandhills.tradepubwebsite.mvc.viewall' /></a>
                        </div>}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default SandhillsAccordion;